// import { Images } from '@business/assets/images';
import { SVGAssets } from '@business/assets/vectors';
import { RootState } from '@reduxjs/toolkit/query';
import { apiSlices } from '@utils/helpers/lib/getState';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface AppLoaderProps {
  isLoading?: boolean;
}

export const AppLoader = ({ isLoading }: AppLoaderProps = {}) => {
  const isPending = useSelector((state: RootState<any, any, any>) => state);
  const dispatch = useDispatch();
  const [isPendingData, setIsPendingData] = useState<boolean>(false);
  const ignoreList = [
    'getPeopleByName',
    'assetSearch',
    'addFavorites',
    'addLikes',
    'deleteLikes',
    'getLikes',
    'getCounts',
    'addComments',
    'deleteComments',
    'getComments',
    'addCommentLikes',
    'deleteCommentLikes',
    'getCommentLikes',
    'updateComments',
    'createPersonWithSync',
    'updatePersonWithSync',
    'getPeopleBySubscriber',
    'saveTreePositions',
    'getTreePositions',
    'userFolderSearch',
    'getMomentDiary',
    'recipesCategoryList',
    'getAssetThings',
    'getAssetLocations',
    'getAssetTypeList',
    'getAssetActivitiesCount',
    'assetsShareWithMe',
    'assetCount',
    'getPhotoTagRecommendations',
    'getUnsharedPeopleById',
    'getUninvitedPeople',
    'getUnreadNotificationCount'
  ] as any;
  useEffect(() => {
    const pendingData = Object.values(isPending)
      ?.filter((item: any) => item?.queries || item?.mutations)
      ?.flatMap((item: any) => [
        ...Object.values(item.queries || {}),
        ...Object.values(item.mutations || {})
      ])
      ?.filter((item: any) => {
        return (
          !ignoreList.includes(item?.endpointName) &&
          !(
            item?.endpointName === 'assetSearch' &&
            item?.data?.data?.count === 1
          )
        );
      })
      ?.some((query: any) => query.status === 'pending');
    setIsPendingData(pendingData ? pendingData : false);
  }, [isPending]);

  useEffect(() => {
    const rejectPendingRequests = () => {
      const pendingEndpoints = Object.values(isPending)
        ?.filter((item: any) => item?.queries || item?.mutations)
        ?.flatMap((item: any) => [
          ...Object.values(item.queries || {}),
          ...Object.values(item.mutations || {})
        ])
        ?.filter((item: any) => !ignoreList.includes(item?.endpointName))
        ?.filter((query: any) => query.status === 'pending');
      if (pendingEndpoints?.length > 0) {
        const pendingApis = pendingEndpoints?.map(
          (item: any) => item.endpointName
        );

        apiSlices.forEach((api: any) => {
          const apiEndpoints = Object.keys(api?.endpoints ?? {});
          const hasPending = apiEndpoints?.some(endpoint =>
            pendingApis?.includes(endpoint)
          );
          if (hasPending) {
            dispatch(api?.util?.resetApiState());
          }
        });
      }
    };
    rejectPendingRequests();
  }, []);

  // Show loader if either manual isLoading is true OR Redux queries are pending
  const shouldShowLoader = isLoading !== undefined ? isLoading : isPendingData;

  return (
    <>
      {shouldShowLoader && (
        <div
          data-testid="loader"
          className="z-[99999] fixed top-0 left-0 w-screen h-screen flex items-center justify-center backdrop-blur-[12px] bg-white/80 select-none overflow-hidden">
          <div className="flex flex-col items-center">
            <SVGAssets.HeaderLogo className="h-52 w-52 animate-pulse" />
          </div>
        </div>
      )}
    </>
  );
};
